const PADDING_FIX = 71;

export default function Dropdown (query) {
    const el = document.querySelector(query);
    if (!el) return;

    const heading = el.querySelector('.notifications-form--dropdown-heading');
    if (!heading) return;

    const content = el.querySelector('.notifications-form--dropdown-content');
    if (!content) return;

    heading.addEventListener('click', (event) => {
        event.stopPropagation();

        const isCollapsed = el.classList.contains('collapsed');

        if (!isCollapsed) {
            el.classList.add('collapsed');

            let height = 0;

            content.style.maxHeight = 'auto';
            height = content.scrollHeight + PADDING_FIX;
            content.style.maxHeight = 0;

            setTimeout(() => content.style.maxHeight = `${height}px`);
        } else {
            el.classList.remove('collapsed');

            content.style.maxHeight = 0;
        }
    });
}